import React from 'react';
import ScrollTrigger from 'react-scroll-trigger';
import BlackOverlay from '../../partials/black_overlay';
import Footer from '../footer';
import NavBar from '../navbar';
import Contact from '../contact';
import Logo from '../logo';
import Burger from '../burger';

class One extends React.Component {
    state = {
        navBarTransparent: false,
        menuOpen: false
    }
    componentDidMount = () => { window.scrollTo(0, 0); }
    onEnterViewport = () => this.setState({ navBarTransparent: true });
    onExitViewport = () => this.setState({ navBarTransparent: false });
    onToggleMenu = () => this.setState({ menuOpen: !this.state.menuOpen });

    render() {
        const { navBarTransparent, menuOpen } = this.state, { nbs, bi } = this.props;

        return <section>
            {/* Navbar */}
            <div className={`w3-top nav-bar  ${navBarTransparent ? 'nav-bar-transparent' : 'w3-card'}`}>
                <Contact />
                <div className={`w3-bar d-flex flex-row  w3-content font-11`} style={{ height: 70, zIndex: 2 }}>
                    <Logo />
                    <NavBar nbs={nbs} />
                    <a className="w3-button w3-padding-large ml-auto w3-hide-medium w3-hide-large flex-row justify-content-center burger bg-black"
                        onClick={this.onToggleMenu}>
                        <i className="fa fa-bars white align-self-center font-20" />
                    </a>
                </div>
            </div>

            <div className={`w3-sidebar w3-bar-block w3-card w3-animate-right w3-center bg-black white ${menuOpen ? '' : 'w3-hide'}`}
                style={{ right: 0, width: '90%', zIndex: 4 }}>
                <Burger onToggleMenu={this.onToggleMenu} />
            </div>

            <div>
                <div
                    style={{
                        minHeight: 600, position: 'absolute', top: 0, left: 0, right: 0,
                        background: `url("/images/backgrounds/${bi}") no-repeat center center`, backgroundSize: 'cover'
                    }}>
                    <BlackOverlay />
                </div>
                {React.cloneElement(this.props.children, this.props)}
            </div>

            <ScrollTrigger onEnter={this.onEnterViewport} onExit={this.onExitViewport} triggerOnLoad={true}
                style={{ position: 'absolute', top: 150, height: 50 }} throttleScroll={0} />

            <div style={{ height: 48 }} />

            <footer className={`w3-container p-2 w3-black show`}>
                <Footer />
            </footer>

        </section>
    }
}

export default One;


// WEBPACK FOOTER //
// ./src/components/layouts/one/index.js